import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const supportedLanguages = {
    en: 'English',
    ru: 'Русский',
    uz: 'O\'zbek',
    sl: 'Slovenščina',
    es: 'Español'
};

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        lng: 'en',
        fallbackLng: 'en',
        supportedLngs: Object.keys(supportedLanguages),
        debug: true, // включаем отладку

        interpolation: {
            escapeValue: false,
        },

        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
        }
    })
    .then(() => {
        console.log('✅ i18n initialized successfully!');
        console.log('Current language:', i18n.language);
        console.log('Test translation:', i18n.t('welcome'));

        // Добавляем в window для тестирования
        (window as any).i18next = i18n;
    })
    .catch((error) => {
        console.error('❌ i18n initialization failed:', error);
    });

export default i18n;
